import React, { Component } from 'react';

import { Link } from 'react-router';

import { ListItem } from 'material-ui/List';
import Avatar from 'material-ui/Avatar';
import IconMenu from 'material-ui/IconMenu';
import IconButton from 'material-ui/IconButton';
import InfoIcon from 'material-ui/svg-icons/action/info';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import * as Colors from 'material-ui/styles/colors';
import { avatar as avatarColours } from '../../constants/ColourConstants';

import CalendarIcon from 'material-ui/svg-icons/action/date-range';
import CalendarActions from '../../actions/CalendarActionCreator';

import ROLES from '../../constants/Roles';
import buildContextMenu from '../Common/BuildContextMenu';
import PropTypes from 'prop-types';

class CalendarListItem extends Component {


    render() {

        const row = this.props.data;

        const infoLink = '/dashboard/calendar/' + row.id;

        const style = {
            menu: {
                marginRight: 0,
                marginBottom: 0,
                float: 'left',
                position: 'relative',
                zIndex: 0,
            },
            menuItem: {
                color: '#CC0000',
            },
            iconButton: {
                marginRight: 0,
            },
            listItem: {
                padding: '2px',
            },
        };

        let actions = [

            {
                link: infoLink,
                label: 'Preview',
                icon: <InfoIcon />
            },
            { 
                type:'divider'
            },
            {
                type: 'deleteDialog',
                dialogType: 'menu',
                value: row.id,
                title: 'Delete course',
                deleteAction: CalendarActions.delete,
                message: (
                            <span>
                                Are you sure to delete the calendar  "{row.name}" ?
                            </span>
                        ),
                condition: {
                    show:  row.sysStatus > 4,
                    roles: [ROLES.ADMIN]
                }
            }
        ];

        let menuItems = buildContextMenu(actions, this.context.auth);

        return (

            <ListItem
                style={style.listItem}
                leftAvatar={
                    <Link to={infoLink}>
                        <Avatar 
                            icon={<CalendarIcon />}
                            style={avatarColours.default}
                        />
                    </Link>
                }
                primaryText={
                    <Link to={infoLink} className="primaryText">
                    {row.name}
                    </Link>
                }
                secondaryText={
                    <Link to={infoLink}>
                    {row.description} <br />
                    -
                    </Link>
                }
                secondaryTextLines={2}
                rightIcon={
                    <IconMenu
                        menuStyle={style.menu}
                        anchorOrigin={{horizontal: 'right', vertical: 'top'}}
                        targetOrigin={{horizontal: 'right', vertical: 'top'}}
                        iconButtonElement={
                            <IconButton
                                touch={true}
                                style={style.iconButton}
                            >
                                <MoreVertIcon  color={Colors.grey400} />
                            </IconButton>
                        }
                    >
                            {menuItems}
                    </IconMenu>
                }

              />
        )
    }
}

CalendarListItem.contextTypes = {
    auth: PropTypes.object.isRequired
};

export default CalendarListItem;
